export var KYC_ENTITY_FETCH_REQUEST = 'KYC_ENTITY_FETCH_REQUEST';
export var KYC_ENTITY_FETCH_SUCCESS = 'KYC_ENTITY_FETCH_SUCCESS';
export var KYC_ENTITY_FETCH_FAIL = 'KYC_ENTITY_FETCH_FAIL';
export var KYC_ENTITY_ADD_SOCIETY = 'KYC_ENTITY_ADD_SOCIETY';
export var KYC_ENTITY_UPDATE_SUCCESS = 'KYC_ENTITY_UPDATE_SUCCESS';
